<div *ngIf="!inline" class="ft2-instant-search-hint" (click)="showSearch()">
    <ng-container *ngIf="!visible">
        <mat-icon class="icon-sm text-light mr-3" [svgIcon]="'search'" />
        <span class="muted-text d-xs-none">Press any key to search</span>
    </ng-container>
</div>

<div class="ft2-instant-search"
     [class.-inline]="inline"
     [class.-visible]="visible"
     [ngClass]="{'transparent': !visible && !inline}">
    <mat-icon class="ft2-instant-search_icon" (click)="showSearch(true)" svgIcon="search" />
    <input #input
           class="ft2-instant-search_input"
           (keydown)="$event.stopPropagation()"
           (ngModelChange)="valueChange.next($event)"
           [ftRestrictInput]="'^[\\w\\s-]*$'"
           [ngModel]="value"
           autocomplete="off"
           ftAutofocus
           type="text"/>
    <button class="ft2-btn-text ft2-instant-search_close" (click)="clearSearch()">
        <mat-icon class="icon-xs" svgIcon="close" />
    </button>
</div>
